{
  "search": "Szukaj",
  "searchWithin": "Szukaj w następującym zakresie"
}
